{
  "enum": {
    "ExcIceGsmV1ApexAssetType": {
      "BANK_LOAN": "Bank Loan",
      "COLLATERALIZED_MORTGAGE_OBLIGATION_ASSET_BACKED_SECURITY": "Collateralized Mortgage Obligation/Asset-Backed Security",
      "COMMODITY": "Commodity",
      "COMMON_EQUITY": "Common Equity",
      "COMPOSITE_UNIT": "Composite Unit",
      "CORPORATE_BOND": "Corporate Bond",
      "CURRENCY": "Currency",
      "DEBT_EQUITY_HYBRID": "Debt/Equity Hybrid",
      "EXCHANGE_TRADED_FUND": "Exchange Traded Fund",
      "FUTURE": "Future",
      "GOVERNMENT_AGENCY_BOND": "Government/Agency Bond",
      "HYBRID": "Hybrid",
      "INDEX": "Index",
      "MBS_GENERIC": "MBS Generic",
      "MONEY_MARKET": "Money Market",
      "MONEY_MARKET_FUND": "Money Market Fund",
      "MORTGAGE_BACKED_SECURITY": "Mortgage-Backed Security",
      "MUTUAL_FUND_UNIT_INVESTMENT_TRUST": "Mutual Fund/Unit Investment Trust",
      "NON_US_MORTGAGE_BACKED_SECURITY": "Non-US Mortgage-Backed Security",
      "OPTION": "Option",
      "OTHER": "Other",
      "OVER_THE_COUNTER_OTC": "Over-the-counter (OTC)",
      "PREFERRED_EQUITY": "Preferred Equity",
      "RIGHT": "Right",
      "STRATEGY": "Strategy",
      "SWAP": "Swap",
      "UNSPECIFIED": "Unspecified",
      "US_MUNICIPAL_BOND": "US Municipal Bond",
      "WARRANT": "Warrant"
    },
    "ExcIceGsmV1ApexBroadNarrowIndicator": {
      "BROAD": "Broad",
      "NARROW": "Narrow",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1ApexFundSource": {
      "BATS": "BATS",
      "NASDAQ": "NASDAQ",
      "NEW_YORK_STOCK_EXCHANGE": "New York Stock Exchange",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1BondIssueStatus": {
      "DEAD": "Dead",
      "LIVE": "Live",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1EntitlementType": {
      "CALL_WARRANT": "Call Warrant",
      "EXOTIC_WARRANT": "Exotic Warrant",
      "NONE": "None",
      "PUT_WARRANT": "Put Warrant",
      "RIGHT": "Right",
      "UNSPECIFIED": "Unspecified",
      "WARRANT_DEPRECATED": "Warrant (deprecated)"
    },
    "ExcIceGsmV1EquityType": {
      "COMMON_ORDINARY_STOCK": "Common/Ordinary Stock",
      "NONE": "None",
      "PREFERRED_PREFERENCE": "Preferred/Preference",
      "SHARE_OF_BENEFICIAL_INTEREST": "Share of Beneficial Interest",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1EtfDbFundType": {
      "ACTIVE": "Active",
      "LEVERAGED": "Leveraged",
      "PASSIVE": "Passive",
      "QUANTITATIVE": "Quantitative",
      "SHORT": "Short",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1EtfDbSectorType": {
      "ALTERNATIVES": "Alternatives",
      "ASSET_ALLOCATION": "Asset Allocation",
      "BLENDED": "Blended",
      "COMMODITY": "Commodity",
      "CURRENCY": "Currency",
      "EQUITY": "Equity",
      "FIXED_INCOME": "Fixed Income",
      "GLOBAL_EQUITY": "Global Equity",
      "GLOBAL_FIXED_INCOME": "Global Fixed Income",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1EtfDbStructureType": {
      "ETF": "ETF",
      "ETMF": "ETMF",
      "ETN": "ETN",
      "ETP": "ETP",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1EtfDbSubSectorType": {
      "AGRICULTURE_FUNDS": "Agriculture funds",
      "BASIC_MATERIALS_FUNDS": "Basic materials funds",
      "BETA_FOCUSED_FUNDS": "Beta focused funds",
      "BROAD_CREDIT": "Broad Credit",
      "BROAD_MARKET": "Broad Market",
      "CAPITAL_APPRECIATION_FUNDS": "Capital appreciation funds",
      "CHINA_REGION_FUNDS": "China region funds",
      "CONSUMER_DISCRETIONARY": "Consumer Discretionary",
      "CONSUMER_GOODS_FUNDS": "Consumer goods funds",
      "CONSUMER_SERVICES_FUNDS": "Consumer services funds",
      "CONSUMER_STAPLES": "Consumer Staples",
      "CORPORATE_DEBT_FUNDS": "Corporate debt funds",
      "CRYPTOCURRENCY": "Cryptocurrency",
      "DEVELOPED_MARKETS_FUNDS": "Developed markets funds",
      "DIVERSIFIED_LEVERAGE_FUNDS": "Diversified leverage funds",
      "EMERGING_MARKETS_DEBT_FUNDS": "Emerging markets debt funds",
      "EMERGING_MARKETS_FUNDS": "Emerging markets funds",
      "ENERGY": "Energy",
      "EUROPEAN_REGION_FUNDS": "European region funds",
      "EXTENDED_MARKET": "Extended Market",
      "FINANCIAL_SERVICES_FUNDS": "Financial services funds",
      "FLEXIBLE_PORTFOLIO_FUNDS": "Flexible portfolio funds",
      "FRONTIER_MARKETS_FUNDS": "Frontier markets funds",
      "GLOBAL_FUNDS": "Global funds",
      "GLOBAL_MACRO": "Global Macro",
      "GOLD_ORIENTED_FUNDS": "Gold oriented funds",
      "GROWTH_AND_INCOME_FUNDS": "Growth and income funds",
      "GROWTH_FUNDS": "Growth funds",
      "HEALTH_BIOTECHNOLOGY_FUNDS": "Health/biotechnology funds",
      "HIGH_DIVIDEND_YIELD": "High Dividend Yield",
      "HIGH_YIELD": "High Yield",
      "INCOME_FUNDS": "Income funds",
      "INDUSTRIALS_FUNDS": "Industrials funds",
      "INFRASTRUCTURE_FUNDS": "Infrastructure Funds",
      "INTERNATIONAL_FUNDS": "International funds",
      "INTERNATIONAL_INCOME_FUNDS": "International income funds",
      "INTERNATIONAL_REAL_ESTATE_FUNDS": "International real estate funds",
      "INVESTMENT_GRADE": "Investment Grade",
      "JAPANESE_FUNDS": "Japanese funds",
      "LARGE_CAP_FUNDS": "Large-cap funds",
      "LATIN_AMERICAN_FUNDS": "Latin American funds",
      "LONG_SHORT_EQUITY_FUNDS": "Long/short equity funds",
      "MICRO_CAP_FUNDS": "Micro-cap funds",
      "MID_CAP_FUNDS": "Mid-cap funds",
      "MONEY_MARKET_FUNDS": "Money market funds",
      "MULTI_CAP_FUNDS": "Multi-cap funds",
      "MULTI_STRATEGY": "Multi Strategy",
      "MUNICIPAL_DEBT_FUNDS": "Municipal debt funds",
      "NON_PRECIOUS_METALS_FUNDS": "Non-precious metals funds",
      "PACIFIC_REGION_FUNDS": "Pacific region funds",
      "PRECIOUS_METALS_FUNDS": "Precious metals funds",
      "REAL_ESTATE_FUNDS": "Real estate funds",
      "SCIENCE_AND_TECHNOLOGY_FUNDS": "Science and technology funds",
      "SMALL_CAP_FUNDS": "Small-cap funds",
      "SPECIALTY_ASSET": "Specialty Asset",
      "SPECIALTY_CURRENCY_FUND": "Specialty: currency fund",
      "SPECIALTY_EQUITY_FUNDS": "Specialty: equity funds",
      "SPECIALTY_FIXED_INCOME_FUNDS": "Specialty: fixed income funds",
      "SPREADS": "Spreads",
      "TARGET_DATE": "Target Date",
      "TARGET_OUTCOME": "Target Outcome",
      "TARGET_RISK": "Target Risk",
      "TELECOMMUNICATION_FUNDS": "Telecommunication funds",
      "THEME": "Theme",
      "TOTAL_MARKET": "Total Market",
      "TREASURY_INFLATION_PROTECTED_SECURITIES": "Treasury inflation protected securities",
      "ULTRA_SHORT_OBLIGATIONS_FUNDS": "Ultra-short obligations funds",
      "UNSPECIFIED": "Unspecified",
      "UTILITY_FUNDS": "Utility funds",
      "U_S_GOVERNMENT_FUNDS": "U.S. Government funds",
      "U_S_MORTGAGE_FUNDS": "U.S. Mortgage funds",
      "U_S_TREASURY_FUNDS": "U.S. Treasury funds",
      "VALUE_FUNDS": "Value funds",
      "VOLATILITY_FOCUSED_FUND": "Volatility focused fund"
    },
    "ExcIceGsmV1FundAssetType": {
      "AFRICAN_EQUITY_INDEX": "African Equity Index",
      "AREA_EURO_BOND_INDEX": "Area Euro Bond Index",
      "ASIAN_EQUITY_INDEX": "Asian Equity Index",
      "AUSTRALIAN_EQUITY_INDEX": "Australian Equity Index",
      "BALANCED": "Balanced",
      "BALANCED_BOND": "Balanced Bond",
      "BALANCED_EQUITY": "Balanced Equity",
      "BALANCED_INCOME": "Balanced Income",
      "BLUE_CHIP": "Blue Chip",
      "BOND": "Bond",
      "BONDS_CURRENCY": "Bonds - Currency",
      "BONDS_GEOGRAPHIC_AREA": "Bonds - Geographic Area",
      "BONDS_GOVERNMENTS": "Bonds - Governments",
      "BONDS_HIGH_YIELD": "Bonds - High Yield",
      "BONDS_INTERNATIONAL": "Bonds - International",
      "BONDS_INVESTMENT_GRADE": "Bonds - Investment Grade",
      "BONDS_NOT_SPECIALIST": "Bonds - Not Specialist",
      "COMMODITY": "Commodity",
      "COMMODITY_INDEX": "Commodity Index",
      "CONVERTIBLE": "Convertible",
      "CORPORATE_BOND": "Corporate Bond",
      "COUNTRY_BONDS_INDEX": "Country Bonds Index",
      "COUNTRY_SHARES_INDEX": "Country Shares Index",
      "CRYPTOCURRENCIES": "Cryptocurrencies",
      "CURRENCIES_INDEX": "Currencies Index",
      "DERIVATIVE": "Derivative",
      "DERIVATIVES_INDEX": "Derivatives Index",
      "DERIVATIVES_INDEX_RAW_MATERIALS": "Derivatives Index - Raw Materials",
      "DISTRESSED_SECURITIES": "Distressed Securities",
      "DIVERSIFIED_FLEXIBLE": "Diversified/Flexible",
      "EQUITY": "Equity",
      "EQUITY_BASKET": "Equity Basket",
      "EQUITY_BEAR": "Equity Bear",
      "EQUITY_GROWTH": "Equity Growth",
      "EQUITY_INCOME": "Equity Income",
      "EQUITY_INDEX_EMERGING_COUNTRIES": "Equity Index - Emerging Countries",
      "EQUITY_INDEX_GEOGRAPHIC_AREA": "Equity Index - Geographic Area",
      "ETHICAL_EQUITY_INDEX": "Ethical Equity Index",
      "EUROPE_BOND_INDEX": "Europe Bond Index",
      "EUROPE_EQUITY_INDEX": "Europe Equity Index",
      "EURO_AREA_EQUITY_INDEX": "Euro Area Equity Index",
      "FEEDER": "Feeder",
      "FUNDS": "Funds",
      "FUND_OF_FUNDS": "Fund of Funds",
      "FUTURES": "Futures",
      "GOODS": "Goods",
      "GOVERNMENT_SECURITIES": "Government Securities",
      "GUARANTEED": "Guaranteed",
      "HIGH_YIELD_BOND": "High Yield Bond",
      "INDEX": "Index",
      "INDEX_CRYPTOCURRENCIES": "Index - Cryptocurrencies",
      "INDEX_OF_ET_FS_BALANCED": "Index Of ETFs - Balanced",
      "INDEX_OF_ET_FS_BONDS": "Index Of ETFs - Bonds",
      "INDEX_OF_ET_FS_FLEXIBLE": "Index Of ETFs - Flexible",
      "INDEX_OF_ET_FS_SHARES": "Index Of ETFs - Shares",
      "INDEX_OF_FUNDS_BONDS": "Index Of Funds - Bonds",
      "INTERNATIONAL_BOND_INDEX": "International Bond Index",
      "INTERNATIONAL_EQUITY_INDEX": "International Equity Index",
      "LARGE_CAP_STOCKS": "Large-Cap Stocks",
      "LONG_TERM_BOND": "Long-Term Bond",
      "MEDIUM_TERM_BOND": "Medium-Term Bond",
      "MICRO_CAP_STOCKS": "Micro-Cap Stocks",
      "MID_CAP_STOCKS": "Mid-Cap Stocks",
      "MIXED_ASSETS": "Mixed Assets",
      "MONEY_MARKET": "Money Market",
      "NON_USA_AMERICAN_BOND_INDEX": "Non-USA American Bond Index",
      "NON_USA_AMERICAN_EQUITY_INDEX": "Non-USA American Equity Index",
      "OPTIONS": "Options",
      "REAL_ESTATE": "Real Estate",
      "SECTOR_EQUITY_INDEX": "Sector Equity Index",
      "SECURITIES_AND_REAL_ESTATE": "Securities and Real Estate",
      "SHARES_GEOGRAPHIC_AREA": "Shares - Geographic Area",
      "SHARES_GLOBAL": "Shares Global",
      "SHARES_OTHERS": "Shares - Others",
      "SHARES_SECTOR": "Shares - Sector",
      "SHARES_SPECIALIST": "Shares - Specialist",
      "SHORT_TERM_BOND": "Short Term Bond",
      "SMALL_CAP_STOCKS": "Small-Cap Stocks",
      "SMALL_MIDDLE_CAP_STOCK": "Small/Middle Cap Stock",
      "TRADED_ENDOWMENT_POLICY": "Traded Endowment Policy",
      "UNSPECIFIED": "Unspecified",
      "USA_BOND_INDEX": "USA Bond Index",
      "USA_EQUITY_INDEX": "USA Equity Index",
      "VENTURE_CAPITAL": "Venture Capital",
      "WARRANTS": "Warrants",
      "ZERO_COUPON_BOND": "Zero-Coupon Bond"
    },
    "ExcIceGsmV1FundType": {
      "CLOSED_ENDED": "Closed Ended",
      "ETF": "ETF",
      "EXCHANGE_TRADED_COMMODITY_ETC": "Exchange Traded Commodity (ETC)",
      "EXCHANGE_TRADED_MANAGED_FUNDS": "Exchange Traded Managed Funds",
      "MONEY_MARKET_FUND": "Money Market Fund",
      "NONE": "None",
      "OPALS": "Opals",
      "OPEN_ENDED": "Open Ended",
      "OTHER": "Other",
      "ULTRA_SHORT_FUND": "Ultra Short Fund",
      "UNIT_INVESTMENT_TRUST": "Unit Investment Trust",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1GsmIndustrySector": {
      "ABS_AIRLINE_LEASES": "ABS Airline Leases",
      "ABS_AUTOMOBILE": "ABS Automobile",
      "ABS_AUTOMOBILE_2": "ABS Automobile",
      "ABS_CONSUMER_LOANS": "ABS Consumer Loans",
      "ABS_CREDIT_CARDS": "ABS Credit Cards",
      "ABS_EQUIPMENT_LEASES": "ABS Equipment Leases",
      "ABS_HOME_EQUITY_LOANS": "ABS Home Equity Loans",
      "ABS_MANUFACTURED_HOUSING": "ABS Manufactured Housing",
      "ABS_MISCELLANEOUS": "ABS Miscellaneous",
      "ABS_STUDENT_LOANS": "ABS Student Loans",
      "ABS_TIMESHARES": "ABS Timeshares",
      "ABS_UTILITIES": "ABS Utilities",
      "ABS_WHOLE_BUSINESS_FRANCHISE_LOANS": "ABS Whole Business & Franchise Loans",
      "ADVERTISING": "Advertising",
      "AEROSPACE_DEFENSE": "Aerospace/Defense",
      "AGENCY": "Agency",
      "AGENCY_CMBS": "Agency CMBS",
      "AIR_TRANSPORTATION": "Air Transportation",
      "AUTOMAKERS": "Automakers",
      "AUTO_LOANS": "Auto Loans",
      "AUTO_PARTS_EQUIPMENT": "Auto Parts & Equipment",
      "BANKING": "Banking",
      "BEVERAGE": "Beverage",
      "BROKERAGE": "Brokerage",
      "BUILDING_CONSTRUCTION": "Building & Construction",
      "BUILDING_MATERIALS": "Building Materials",
      "CABLE_SATELLITE_TV": "Cable & Satellite TV",
      "CHEMICALS": "Chemicals",
      "CMO_OTHER": "CMO Other",
      "COMMERCIAL_MORTGAGE_BACKED": "Commercial Mortgage Backed",
      "CONS_COMM_LEASE_FINANCING": "Cons/Comm/Lease Financing",
      "CVT_ADVERTISING": "Cvt-Advertising",
      "CVT_AEROSPACE_DEFENSE": "Cvt-Aerospace/Defense",
      "CVT_AIR_TRANSPORTATION": "Cvt-Air Transportation",
      "CVT_AUTOMAKERS": "Cvt-Automakers",
      "CVT_AUTO_LOANS": "Cvt-Auto Loans",
      "CVT_AUTO_PARTS_EQUIPMENT": "Cvt-Auto Parts & Equipment",
      "CVT_BANKING": "Cvt-Banking",
      "CVT_BEVERAGE": "Cvt-Beverage",
      "CVT_BROKERAGE": "Cvt-Brokerage",
      "CVT_BUILDING_CONSTRUCTION": "Cvt-Building & Construction",
      "CVT_BUILDING_MATERIALS": "Cvt-Building Materials",
      "CVT_CABLE_SATELLITE_TV": "Cvt-Cable & Satellite TV",
      "CVT_CHEMICALS": "Cvt-Chemicals",
      "CVT_CONS_COMM_LEASE_FINANCING": "Cvt-Cons/Comm/Lease Financing",
      "CVT_DEPARTMENT_STORES": "Cvt-Department Stores",
      "CVT_DISCOUNT_STORES": "Cvt-Discount Stores",
      "CVT_DIVERSIFIED_CAPITAL_GOODS": "Cvt-Diversified Capital Goods",
      "CVT_ELECTRIC_DISTR_TRANS": "Cvt-Electric-Distr/Trans",
      "CVT_ELECTRIC_GENERATION": "Cvt-Electric-Generation",
      "CVT_ELECTRIC_INTEGRATED": "Cvt-Electric-Integrated",
      "CVT_ELECTRONICS": "Cvt-Electronics",
      "CVT_ENERGY_EXPLORATION_PRODUCTION": "Cvt-Energy - Exploration & Production",
      "CVT_ENVIRONMENTAL": "Cvt-Environmental",
      "CVT_FOOD_DRUG_RETAILERS": "Cvt-Food & Drug Retailers",
      "CVT_FOOD_WHOLESALE": "Cvt-Food - Wholesale",
      "CVT_FORESTRY_PAPER": "Cvt-Forestry/Paper",
      "CVT_GAMING": "Cvt-Gaming",
      "CVT_GAS_DISTRIBUTION": "Cvt-Gas Distribution",
      "CVT_HEALTH_FACILITIES": "Cvt-Health Facilities",
      "CVT_HEALTH_SERVICES": "Cvt-Health Services",
      "CVT_HOTELS": "Cvt-Hotels",
      "CVT_HOUSING_ASSOCIATION": "Cvt-Housing Association",
      "CVT_INSURANCE_BROKERAGE": "Cvt-Insurance Brokerage",
      "CVT_INTEGRATED_ENERGY": "Cvt-Integrated Energy",
      "CVT_INVESTMENTS_MISC_FINANCIAL_SERVICES": "Cvt-Investments & Misc Financial Services",
      "CVT_LIFE_INSURANCE": "Cvt-Life Insurance",
      "CVT_MACHINERY": "Cvt-Machinery",
      "CVT_MANAGED_CARE": "Cvt-Managed Care",
      "CVT_MEDIA_CONTENT": "Cvt-Media Content",
      "CVT_MEDIA_DIVERSIFIED": "Cvt-Media - Diversified",
      "CVT_MEDICAL_PRODUCTS": "Cvt-Medical Products",
      "CVT_METALS_MINING_EXCLUDING_STEEL": "Cvt-Metals/Mining Excluding Steel",
      "CVT_MONOLINE_INSURANCE": "Cvt-Monoline Insurance",
      "CVT_MULTI_LINE_INSURANCE": "Cvt-Multi-Line Insurance",
      "CVT_NON_ELECTRIC_UTILITIES": "Cvt-Non-Electric Utilities",
      "CVT_OIL_FIELD_EQUIPMENT_SERVICES": "Cvt-Oil Field Equipment & Services",
      "CVT_OIL_REFINING_MARKETING": "Cvt-Oil Refining & Marketing",
      "CVT_PACKAGING": "Cvt-Packaging",
      "CVT_PERSONAL_HOUSEHOLD_PRODUCTS": "Cvt-Personal & Household Products",
      "CVT_PHARMACEUTICALS": "Cvt-Pharmaceuticals",
      "CVT_PRINTING_PUBLISHING": "Cvt-Printing & Publishing",
      "CVT_P_C": "Cvt-P&C",
      "CVT_RAIL": "Cvt-Rail",
      "CVT_REAL_ESTATE_DEV_MGT": "Cvt-RealEstate Dev & Mgt",
      "CVT_RECREATION_TRAVEL": "Cvt-Recreation & Travel",
      "CVT_REINSURANCE": "Cvt-Reinsurance",
      "CVT_REI_TS": "Cvt-REITs",
      "CVT_RESTAURANTS": "Cvt-Restaurants",
      "CVT_SOFTWARE_SERVICES": "Cvt-Software/Services",
      "CVT_SPECIALTY_RETAIL": "Cvt-Specialty Retail",
      "CVT_STEEL_PRODUCERS_PRODUCTS": "Cvt-Steel Producers/Products",
      "CVT_SUPPORT_SERVICES": "Cvt-Support-Services",
      "CVT_TECH_HARDWARE_EQUIPMENT": "Cvt-Tech Hardware & Equipment",
      "CVT_TELECOM_SATELLITE": "Cvt-Telecom - Satellite",
      "CVT_TELECOM_WIRELESS": "Cvt-Telecom - Wireless",
      "CVT_TELECOM_WIRELINE_INTEGRATED_SERVICES": "Cvt-Telecom - Wireline Integrated & Services",
      "CVT_THEATERS_ENTERTAINMENT": "Cvt-Theaters & Entertainment",
      "CVT_TOBACCO": "Cvt-Tobacco",
      "CVT_TRANSPORT_INFRASTRUCTURE_SERVICES": "Cvt-Transport Infrastructure/Services",
      "CVT_TRUCKING_DELIVERY": "Cvt-Trucking & Delivery",
      "DEPARTMENT_STORES": "Department Stores",
      "DISCOUNT_STORES": "Discount Stores",
      "DIVERSIFIED_CAPITAL_GOODS": "Diversified Capital Goods",
      "ELECTRIC_DISTR_TRANS": "Electric-Distr/Trans",
      "ELECTRIC_GENERATION": "Electric-Generation",
      "ELECTRIC_INTEGRATED": "Electric-Integrated",
      "ELECTRONICS": "Electronics",
      "ENERGY_EXPLORATION_PRODUCTION": "Energy - Exploration & Production",
      "ENVIRONMENTAL": "Environmental",
      "ETM": "ETM",
      "FOOD_DRUG_RETAILERS": "Food & Drug Retailers",
      "FOOD_WHOLESALE": "Food - Wholesale",
      "FOREIGN_SOVEREIGN": "Foreign Sovereign",
      "FORESTRY_PAPER": "Forestry/Paper",
      "GAMING": "Gaming",
      "GAS_DISTRIBUTION": "Gas Distribution",
      "GOVERNMENT_GUARANTEED": "Government Guaranteed",
      "GO_LOCAL": "GO - Local",
      "GO_STATE": "GO - State",
      "HEALTH_FACILITIES": "Health Facilities",
      "HEALTH_SERVICES": "Health Services",
      "HOTELS": "Hotels",
      "HOUSING_ASSOCIATION": "Housing Association",
      "INSURANCE_BROKERAGE": "Insurance Brokerage",
      "INTEGRATED_ENERGY": "Integrated Energy",
      "INTEREST_RATE_SWAP": "Interest rate Swap",
      "INVESTMENTS_MISC_FINANCIAL_SERVICES": "Investments & Misc Financial Services",
      "LIFE_INSURANCE": "Life Insurance",
      "LOCAL_AUTHORITY": "Local-Authority",
      "MACHINERY": "Machinery",
      "MANAGED_CARE": "Managed Care",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_DIVERSIFIED": "Media - Diversified",
      "MEDICAL_PRODUCTS": "Medical Products",
      "METALS_MINING_EXCLUDING_STEEL": "Metals/Mining Excluding Steel",
      "MONOLINE_INSURANCE": "Monoline Insurance",
      "MORTGAGE_BACKED": "Mortgage Backed",
      "MORTGAGE_COVERED_BONDS": "Mortgage Covered Bonds",
      "MULTI_LINE_INSURANCE": "Multi-Line Insurance",
      "NON_AGENCY_CMBS": "Non-Agency CMBS",
      "NON_ELECTRIC_UTILITIES": "Non-Electric Utilities",
      "OIL_FIELD_EQUIPMENT_SERVICES": "Oil Field Equipment & Services",
      "OIL_REFINING_MARKETING": "Oil Refining & Marketing",
      "OTHER": "Other",
      "OTHERS": "Others",
      "OTHER_COVERED_BONDS": "Other Covered Bonds",
      "PAC": "PAC",
      "PACKAGING": "Packaging",
      "PAC_Z": "PAC Z",
      "PERSONAL_HOUSEHOLD_PRODUCTS": "Personal & Household Products",
      "PFD_ADVERTISING": "Pfd-Advertising",
      "PFD_AEROSPACE_DEFENSE": "Pfd-Aerospace/Defense",
      "PFD_AGENCY": "Pfd-Agency",
      "PFD_AIR_TRANSPORTATION": "Pfd-Air Transportation",
      "PFD_AUTOMAKERS": "Pfd-Automakers",
      "PFD_AUTOMOTIVE": "Pfd-Automotive",
      "PFD_AUTO_LOANS": "Pfd-Auto Loans",
      "PFD_AUTO_PARTS_EQUIPMENT": "Pfd-Auto Parts & Equipment",
      "PFD_BANKING": "Pfd-Banking",
      "PFD_BASIC_INDUSTRY": "Pfd-Basic Industry",
      "PFD_BEVERAGE": "Pfd-Beverage",
      "PFD_BROKERAGE": "Pfd-Brokerage",
      "PFD_BUILDING_CONSTRUCTION": "Pfd-Building & Construction",
      "PFD_BUILDING_MATERIALS": "Pfd-Building Materials",
      "PFD_CABLE_SATELLITE_TV": "Pfd-Cable & Satellite TV",
      "PFD_CAPITAL_GOODS": "Pfd-Capital Goods",
      "PFD_CHEMICALS": "Pfd-Chemicals",
      "PFD_CONSUMER_GOODS": "Pfd-Consumer Goods",
      "PFD_CONS_COMM_LEASE_FINANCING": "Pfd-Cons/Comm/Lease Financing",
      "PFD_DEPARTMENT_STORES": "Pfd-Department Stores",
      "PFD_DISCOUNT_STORES": "Pfd-Discount Stores",
      "PFD_DIVERSIFIED_CAPITAL_GOODS": "Pfd-Diversified Capital Goods",
      "PFD_ELECTRIC_DISTR_TRANS": "Pfd-Electric-Distr/Trans",
      "PFD_ELECTRIC_GENERATION": "Pfd-Electric-Generation",
      "PFD_ELECTRIC_INTEGRATED": "Pfd-Electric-Integrated",
      "PFD_ELECTRONICS": "Pfd-Electronics",
      "PFD_ENERGY": "Pfd-Energy",
      "PFD_ENERGY_EXPLORATION_PRODUCTION": "Pfd-Energy - Exploration & Production",
      "PFD_ENVIRONMENTAL": "Pfd-Environmental",
      "PFD_FINANCIAL_SERVICES": "Pfd-Financial Services",
      "PFD_FOOD_DRUG_RETAILERS": "Pfd-Food & Drug Retailers",
      "PFD_FOOD_WHOLESALE": "Pfd-Food - Wholesale",
      "PFD_FORESTRY_PAPER": "Pfd-Forestry/Paper",
      "PFD_GAMING": "Pfd-Gaming",
      "PFD_GAS_DISTRIBUTION": "Pfd-Gas Distribution",
      "PFD_HEALTHCARE": "Pfd-Healthcare",
      "PFD_HEALTH_FACILITIES": "Pfd-Health Facilities",
      "PFD_HEALTH_SERVICES": "Pfd-Health Services",
      "PFD_HOTELS": "Pfd-Hotels",
      "PFD_HOUSING_ASSOCIATION": "Pfd-Housing Association",
      "PFD_INSURANCE": "Pfd-Insurance",
      "PFD_INSURANCE_BROKERAGE": "Pfd-Insurance Brokerage",
      "PFD_INTEGRATED_ENERGY": "Pfd-Integrated Energy",
      "PFD_INVESTMENTS_MISC_FINANCIAL_SERVICES": "Pfd-Investments & Misc Financial Services",
      "PFD_LEISURE": "Pfd-Leisure",
      "PFD_LIFE_INSURANCE": "Pfd-Life Insurance",
      "PFD_MACHINERY": "Pfd-Machinery",
      "PFD_MANAGED_CARE": "Pfd-Managed Care",
      "PFD_MEDIA": "Pfd-Media",
      "PFD_MEDIA_CONTENT": "Pfd-Media Content",
      "PFD_MEDIA_DIVERSIFIED": "Pfd-Media - Diversified",
      "PFD_MEDICAL_PRODUCTS": "Pfd-Medical Products",
      "PFD_METALS_MINING_EXCLUDING_STEEL": "Pfd-Metals/Mining Excluding Steel",
      "PFD_MONOLINE_INSURANCE": "Pfd-Monoline Insurance",
      "PFD_MULTI_LINE_INSURANCE": "Pfd-Multi-Line Insurance",
      "PFD_NON_ELECTRIC_UTILITIES": "Pfd-Non-Electric Utilities",
      "PFD_OIL_FIELD_EQUIPMENT_SERVICES": "Pfd-Oil Field Equipment & Services",
      "PFD_OIL_REFINING_MARKETING": "Pfd-Oil Refining & Marketing",
      "PFD_PACKAGING": "Pfd-Packaging",
      "PFD_PERSONAL_HOUSEHOLD_PRODUCTS": "Pfd-Personal & Household Products",
      "PFD_PHARMACEUTICALS": "Pfd-Pharmaceuticals",
      "PFD_PRINTING_PUBLISHING": "Pfd-Printing & Publishing",
      "PFD_P_C": "Pfd-P&C",
      "PFD_QUASI_GOVERNMENT": "Pfd-Quasi Government",
      "PFD_RAIL": "Pfd-Rail",
      "PFD_REAL_ESTATE": "Pfd-Real Estate",
      "PFD_REAL_ESTATE_DEV_MGT": "Pfd-RealEstate Dev & Mgt",
      "PFD_RECREATION_TRAVEL": "Pfd-Recreation & Travel",
      "PFD_REINSURANCE": "Pfd-Reinsurance",
      "PFD_REI_TS": "Pfd-REITs",
      "PFD_RESTAURANTS": "Pfd-Restaurants",
      "PFD_RETAIL": "Pfd-Retail",
      "PFD_SERVICES": "Pfd-Services",
      "PFD_SOFTWARE_SERVICES": "Pfd-Software/Services",
      "PFD_SPECIALTY_RETAIL": "Pfd-Specialty Retail",
      "PFD_STEEL_PRODUCERS_PRODUCTS": "Pfd-Steel Producers/Products",
      "PFD_SUPPORT_SERVICES": "Pfd-Support-Services",
      "PFD_TECHNOLOGY_ELECTRONICS": "Pfd-Technology & Electronics",
      "PFD_TECH_HARDWARE_EQUIPMENT": "Pfd-Tech Hardware & Equipment",
      "PFD_TELECOMMUNICATIONS": "Pfd-Telecommunications",
      "PFD_TELECOM_SATELLITE": "Pfd-Telecom - Satellite",
      "PFD_TELECOM_WIRELESS": "Pfd-Telecom - Wireless",
      "PFD_TELECOM_WIRELINE_INTEGRATED_SERVICES": "Pfd-Telecom - Wireline Integrated & Services",
      "PFD_THEATERS_ENTERTAINMENT": "Pfd-Theaters & Entertainment",
      "PFD_TOBACCO": "Pfd-Tobacco",
      "PFD_TRANSPORTATION": "Pfd-Transportation",
      "PFD_TRANSPORT_INFRASTRUCTURE_SERVICES": "Pfd-Transport Infrastructure/Services",
      "PFD_TRUCKING_DELIVERY": "Pfd-Trucking & Delivery",
      "PFD_UTILITY": "Pfd-Utility",
      "PHARMACEUTICALS": "Pharmaceuticals",
      "PRE_REFUNDED": "Pre-Refunded",
      "PRINTING_PUBLISHING": "Printing & Publishing",
      "PUBLIC_LOAN_COVERED_BONDS": "Public Loan Covered Bonds",
      "P_C": "P&C",
      "RAIL": "Rail",
      "REAL_ESTATE_DEV_MGT": "RealEstate Dev & Mgt",
      "RECREATION_TRAVEL": "Recreation & Travel",
      "REINSURANCE": "Reinsurance",
      "REI_TS": "REITs",
      "RESTAURANTS": "Restaurants",
      "REVENUE_AIRPORT": "Revenue - Airport",
      "REVENUE_EDUCATION": "Revenue - Education",
      "REVENUE_HEALTH": "Revenue - Health",
      "REVENUE_HOSPITALS": "Revenue - Hospitals",
      "REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE": "Revenue - Industrial Development Revenue",
      "REVENUE_LEASING_COPS_APPROPRIATIONS": "Revenue - Leasing COPS & Appropriations",
      "REVENUE_MISC": "Revenue - Misc",
      "REVENUE_MULTI_FAMILY_HOUSING": "Revenue - Multi-Family Housing",
      "REVENUE_POLLUTION_CONTROL": "Revenue - Pollution Control",
      "REVENUE_POWER": "Revenue - Power",
      "REVENUE_SINGLE_FAMILY_HOUSING": "Revenue - Single Family Housing",
      "REVENUE_TAX": "Revenue - Tax",
      "REVENUE_TOBACCO": "Revenue - Tobacco",
      "REVENUE_TOLL_TURNPIKE": "Revenue - Toll & Turnpike",
      "REVENUE_TRANSPORTATION": "Revenue - Transportation",
      "REVENUE_UTILITIES_OTHER": "Revenue - Utilities - Other",
      "REVENUE_WATER_SEWER": "Revenue - Water & Sewer",
      "SEQUENTIAL": "Sequential",
      "SEQUENTIAL_Z": "Sequential Z",
      "SOFTWARE_SERVICES": "Software/Services",
      "SOVEREIGN": "Sovereign",
      "SPECIALTY_RETAIL": "Specialty Retail",
      "STEEL_PRODUCERS_PRODUCTS": "Steel Producers/Products",
      "STRUCTURED_IO": "Structured IO",
      "STRUCTURED_PO": "Structured PO",
      "SUPPORT_SERVICES": "Support-Services",
      "SUPPORT_Z": "Support Z",
      "SUPRANATIONAL": "Supranational",
      "TAXABLE_ETM": "Taxable ETM",
      "TAXABLE_GO_LOCAL": "Taxable GO - Local",
      "TAXABLE_GO_STATE": "Taxable GO - State",
      "TAXABLE_PRE_REFUNDED": "Taxable Pre-Refunded",
      "TAXABLE_REVENUE_AIRPORT": "Taxable Revenue - Airport",
      "TAXABLE_REVENUE_EDUCATION": "Taxable Revenue - Education",
      "TAXABLE_REVENUE_HEALTH": "Taxable Revenue - Health",
      "TAXABLE_REVENUE_HOSPITALS": "Taxable Revenue - Hospitals",
      "TAXABLE_REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE": "Taxable Revenue - Industrial Development Revenue",
      "TAXABLE_REVENUE_LEASING_COPS_APPROPRIATIONS": "Taxable Revenue - Leasing COPS & Appropriations",
      "TAXABLE_REVENUE_MISC": "Taxable Revenue - Misc",
      "TAXABLE_REVENUE_MULTI_FAMILY_HOUSING": "Taxable Revenue - Multi-Family Housing",
      "TAXABLE_REVENUE_POLLUTION_CONTROL": "Taxable Revenue - Pollution Control",
      "TAXABLE_REVENUE_POWER": "Taxable Revenue - Power",
      "TAXABLE_REVENUE_SINGLE_FAMILY_HOUSING": "Taxable Revenue - Single Family Housing",
      "TAXABLE_REVENUE_TAX": "Taxable Revenue - Tax",
      "TAXABLE_REVENUE_TOBACCO": "Taxable Revenue - Tobacco",
      "TAXABLE_REVENUE_TOLL_TURNPIKE": "Taxable Revenue - Toll & Turnpike",
      "TAXABLE_REVENUE_TRANSPORTATION": "Taxable Revenue - Transportation",
      "TAXABLE_REVENUE_UTILITIES_OTHER": "Taxable Revenue - Utilities - Other",
      "TAXABLE_REVENUE_WATER_SEWER": "Taxable Revenue - Water & Sewer",
      "TECH_HARDWARE_EQUIPMENT": "Tech Hardware & Equipment",
      "TELECOM_SATELLITE": "Telecom - Satellite",
      "TELECOM_WIRELESS": "Telecom - Wireless",
      "TELECOM_WIRELINE_INTEGRATED_SERVICES": "Telecom - Wireline Integrated & Services",
      "THEATERS_ENTERTAINMENT": "Theaters & Entertainment",
      "TOBACCO": "Tobacco",
      "TRANSPORT_INFRASTRUCTURE_SERVICES": "Transport Infrastructure/Services",
      "TRUCKING_DELIVERY": "Trucking & Delivery",
      "TRUST_IO": "Trust IO",
      "TRUST_PO": "Trust PO",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1IceAssetClass": {
      "BANK_LOANS": "Bank Loans",
      "CONVERTIBLE": "Convertible",
      "CORPORATE": "Corporate",
      "PREFERRED_SECURITIES": "Preferred Securities",
      "QUASI_FOREIGN_GOVERNMENT": "Quasi & Foreign Government",
      "SECURITIZED_COLLATERALIZED": "Securitized/Collateralized",
      "SOVEREIGN": "Sovereign",
      "UNSPECIFIED": "Unspecified",
      "U_S_TAX_EXEMPT_MUNICIPALS": "U.S. Tax-Exempt Municipals"
    },
    "ExcIceGsmV1IceCategory": {
      "AGENCY": "Agency",
      "ASSET_BACKED": "Asset Backed",
      "AUTOMOTIVE": "Automotive",
      "BANKING": "Banking",
      "BASIC_INDUSTRY": "Basic Industry",
      "CAPITAL_GOODS": "Capital Goods",
      "COLLATERALIZED_MORTGAGE_OBLIGATION": "Collateralized Mortgage Obligation",
      "COMMERCIAL_MORTGAGE_BACKED": "Commercial Mortgage Backed",
      "CONSUMER_GOODS": "Consumer Goods",
      "COVERED_BONDS": "Covered Bonds",
      "CVT_AUTOMOTIVE": "Cvt-Automotive",
      "CVT_AUTOMOTIVE_2": "Cvt-Automotive",
      "CVT_BANKING": "Cvt-Banking",
      "CVT_BASIC_INDUSTRY": "Cvt-Basic Industry",
      "CVT_CAPITAL_GOODS": "Cvt-Capital Goods",
      "CVT_CAPITAL_GOODS_2": "Cvt-Capital Goods",
      "CVT_CONSUMER_GOODS": "Cvt-Consumer Goods",
      "CVT_ENERGY": "Cvt-Energy",
      "CVT_FINANCIAL_SERVICES": "Cvt-Financial Services",
      "CVT_HEALTHCARE": "Cvt-Healthcare",
      "CVT_INSURANCE": "Cvt-Insurance",
      "CVT_INSURANCE_2": "Cvt-Insurance",
      "CVT_LEISURE": "Cvt-Leisure",
      "CVT_MEDIA": "Cvt-Media",
      "CVT_REAL_ESTATE": "Cvt-Real Estate",
      "CVT_RETAIL": "Cvt-Retail",
      "CVT_SERVICES": "Cvt-Services",
      "CVT_TECHNOLOGY_ELECTRONICS": "Cvt-Technology & Electronics",
      "CVT_TELECOMMUNICATIONS": "Cvt-Telecommunications",
      "CVT_TRANSPORTATION": "Cvt-Transportation",
      "CVT_UTILITY": "Cvt-Utility",
      "ENERGY": "Energy",
      "FINANCIAL_SERVICES": "Financial Services",
      "FOREIGN_SOVEREIGN": "Foreign Sovereign",
      "GOVERNMENT_GUARANTEED": "Government Guaranteed",
      "GO_LOCAL": "GO - Local",
      "GO_STATE": "GO - State",
      "HEALTHCARE": "Healthcare",
      "INSURANCE": "Insurance",
      "LEISURE": "Leisure",
      "LOAN_AUTOMOTIVE": "Loan-Automotive",
      "LOAN_BANKING": "Loan-Banking",
      "LOAN_BASIC_INDUSTRY": "Loan-Basic Industry",
      "LOAN_CAPITAL_GOODS": "Loan-Capital Goods",
      "LOAN_CONSUMER_GOODS": "Loan-Consumer Goods",
      "LOAN_ENERGY": "Loan-Energy",
      "LOAN_FINANCIAL_SERVICES": "Loan-Financial Services",
      "LOAN_HEALTHCARE": "Loan-Healthcare",
      "LOAN_INSURANCE": "Loan-Insurance",
      "LOAN_LEISURE": "Loan-Leisure",
      "LOAN_MEDIA": "Loan-Media",
      "LOAN_REAL_ESTATE": "Loan-Real Estate",
      "LOAN_RETAIL": "Loan-Retail",
      "LOAN_SERVICES": "Loan-Services",
      "LOAN_TECHNOLOGY_ELECTRONICS": "Loan-Technology & Electronics",
      "LOAN_TELECOMMUNICATIONS": "Loan-Telecommunications",
      "LOAN_TRANSPORTATION": "Loan-Transportation",
      "LOAN_UTILITY": "Loan-Utility",
      "LOCAL_AUTHORITY": "Local-Authority",
      "MEDIA": "Media",
      "MORTGAGE_BACKED": "Mortgage Backed",
      "PFD_AGENCY": "Pfd-Agency",
      "PFD_AUTOMOTIVE": "Pfd-Automotive",
      "PFD_BANKING": "Pfd-Banking",
      "PFD_BASIC_INDUSTRY": "Pfd-Basic Industry",
      "PFD_CAPITAL_GOODS": "Pfd-Capital Goods",
      "PFD_CONSUMER_GOODS": "Pfd-Consumer Goods",
      "PFD_ENERGY": "Pfd-Energy",
      "PFD_FINANCIAL_SERVICES": "Pfd-Financial Services",
      "PFD_HEALTHCARE": "Pfd-Healthcare",
      "PFD_INSURANCE": "Pfd-Insurance",
      "PFD_LEISURE": "Pfd-Leisure",
      "PFD_MEDIA": "Pfd-Media",
      "PFD_REAL_ESTATE": "Pfd-Real Estate",
      "PFD_RETAIL": "Pfd-Retail",
      "PFD_SERVICES": "Pfd-Services",
      "PFD_TECHNOLOGY_ELECTRONICS": "Pfd-Technology & Electronics",
      "PFD_TELECOMMUNICATIONS": "Pfd-Telecommunications",
      "PFD_TRANSPORTATION": "Pfd-Transportation",
      "PFD_UTILITY": "Pfd-Utility",
      "REAL_ESTATE": "Real Estate",
      "REFUNDED": "Refunded",
      "RETAIL": "Retail",
      "REVENUE_AIRPORT": "Revenue - Airport",
      "REVENUE_EDUCATION": "Revenue - Education",
      "REVENUE_HEALTH": "Revenue - Health",
      "REVENUE_HOSPITALS": "Revenue - Hospitals",
      "REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE": "Revenue - Industrial Development Revenue",
      "REVENUE_LEASING_COPS_APPROPRIATIONS": "Revenue - Leasing COPS & Appropriations",
      "REVENUE_MISC": "Revenue - Misc",
      "REVENUE_MULTI_FAMILY_HOUSING": "Revenue - Multi-Family Housing",
      "REVENUE_POLLUTION_CONTROL": "Revenue - Pollution Control",
      "REVENUE_POWER": "Revenue - Power",
      "REVENUE_SINGLE_FAMILY_HOUSING": "Revenue - Single Family Housing",
      "REVENUE_TAX": "Revenue - Tax",
      "REVENUE_TOBACCO": "Revenue - Tobacco",
      "REVENUE_TOLL_TURNPIKE": "Revenue - Toll & Turnpike",
      "REVENUE_TRANSPORTATION": "Revenue - Transportation",
      "REVENUE_UTILITIES_OTHER": "Revenue - Utilities - Other",
      "REVENUE_WATER_SEWER": "Revenue - Water & Sewer",
      "SERVICES": "Services",
      "SOVEREIGN": "Sovereign",
      "SUPRANATIONAL": "Supranational",
      "TECHNOLOGY_ELECTRONICS": "Technology & Electronics",
      "TELECOMMUNICATIONS": "Telecommunications",
      "TRANSPORTATION": "Transportation",
      "UNSPECIFIED": "Unspecified",
      "UTILITY": "Utility",
      "U_S_TAXABLE_MUNICIPAL": "U.S. Taxable Municipal"
    },
    "ExcIceGsmV1IceGroup": {
      "COVERED": "Covered",
      "CVT_FINANCIAL": "Cvt-Financial",
      "CVT_INDUSTRIALS": "Cvt-Industrials",
      "CVT_UTILITY": "Cvt-Utility",
      "FINANCIAL": "Financial",
      "GO": "GO",
      "INDUSTRIALS": "Industrials",
      "LOAN_FINANCIAL": "Loan-Financial",
      "LOAN_INDUSTRIALS": "Loan-Industrials",
      "LOAN_UTILITY": "Loan-Utility",
      "PFD_FINANCIAL": "Pfd-Financial",
      "PFD_INDUSTRIALS": "Pfd-Industrials",
      "PFD_QUASI_GOVERNMENT": "Pfd-Quasi Government",
      "PFD_UTILITY": "Pfd-Utility",
      "QUASI_FOREIGN_GOVERNMENT": "Quasi & Foreign Government",
      "REFUNDED": "Refunded",
      "REVENUE": "Revenue",
      "SECURITIZED": "Securitized",
      "SOVEREIGN": "Sovereign",
      "UNSPECIFIED": "Unspecified",
      "UTILITY": "Utility"
    },
    "ExcIceGsmV1IceSubcategory": {
      "ABS_AIRLINE_LEASES": "ABS Airline Leases",
      "ABS_AUTOMOBILE": "ABS Automobile",
      "ABS_CONSUMER_LOANS": "ABS Consumer Loans",
      "ABS_CREDIT_CARDS": "ABS Credit Cards",
      "ABS_EQUIPMENT_LEASES": "ABS Equipment Leases",
      "ABS_HOME_EQUITY_LOANS": "ABS Home Equity Loans",
      "ABS_MANUFACTURED_HOUSING": "ABS Manufactured Housing",
      "ABS_MISCELLANEOUS_ABS": "ABS Miscellaneous ABS",
      "ABS_STUDENT_LOANS": "ABS Student Loans",
      "ABS_TIMESHARES": "ABS Timeshares",
      "ABS_UTILITIES": "ABS Utilities",
      "ABS_WHOLE_BUSINESS_FRANCHISE_LOANS": "ABS Whole Business & Franchise Loans",
      "ADVERTISING": "Advertising",
      "AEROSPACE_DEFENSE": "Aerospace/Defense",
      "AGENCY": "Agency",
      "AGENCY_CMBS": "Agency CMBS",
      "AIR_TRANSPORTATION": "Air Transportation",
      "AUTOMAKERS": "Automakers",
      "AUTO_LOANS": "Auto Loans",
      "AUTO_PARTS_EQUIPMENT": "Auto Parts & Equipment",
      "BANKING": "Banking",
      "BEVERAGE": "Beverage",
      "BROKERAGE": "Brokerage",
      "BUILDING_CONSTRUCTION": "Building & Construction",
      "BUILDING_MATERIALS": "Building Materials",
      "CABLE_SATELLITE_TV": "Cable & Satellite TV",
      "CHEMICALS": "Chemicals",
      "CMO_OTHER": "CMO Other",
      "COMMERCIAL_MORTGAGE_BACKED": "Commercial Mortgage Backed",
      "CONS_COMM_LEASE_FINANCING": "Cons/Comm/Lease Financing",
      "CVT_ADVERTISING": "Cvt-Advertising",
      "CVT_AEROSPACE_DEFENSE": "Cvt-Aerospace/Defense",
      "CVT_AIR_TRANSPORTATION": "Cvt-Air Transportation",
      "CVT_AUTOMAKERS": "Cvt-Automakers",
      "CVT_AUTO_LOANS": "Cvt-Auto Loans",
      "CVT_AUTO_PARTS_EQUIPMENT": "Cvt-Auto Parts & Equipment",
      "CVT_BANKING": "Cvt-Banking",
      "CVT_BEVERAGE": "Cvt-Beverage",
      "CVT_BROKERAGE": "Cvt-Brokerage",
      "CVT_BUILDING_CONSTRUCTION": "Cvt-Building & Construction",
      "CVT_BUILDING_MATERIALS": "Cvt-Building Materials",
      "CVT_CABLE_SATELLITE_TV": "Cvt-Cable & Satellite TV",
      "CVT_CHEMICALS": "Cvt-Chemicals",
      "CVT_CONS_COMM_LEASE_FINANCING": "Cvt-Cons/Comm/Lease Financing",
      "CVT_DEPARTMENT_STORES": "Cvt-Department Stores",
      "CVT_DISCOUNT_STORES": "Cvt-Discount Stores",
      "CVT_DIVERSIFIED_CAPITAL_GOODS": "Cvt-Diversified Capital Goods",
      "CVT_ELECTRIC_DISTR_TRANS": "Cvt-Electric-Distr/Trans",
      "CVT_ELECTRIC_GENERATION": "Cvt-Electric-Generation",
      "CVT_ELECTRIC_INTEGRATED": "Cvt-Electric-Integrated",
      "CVT_ELECTRONICS": "Cvt-Electronics",
      "CVT_ENERGY_EXPLORATION_PRODUCTION": "Cvt-Energy - Exploration & Production",
      "CVT_ENVIRONMENTAL": "Cvt-Environmental",
      "CVT_FOOD_DRUG_RETAILERS": "Cvt-Food & Drug Retailers",
      "CVT_FOOD_WHOLESALE": "Cvt-Food - Wholesale",
      "CVT_FORESTRY_PAPER": "Cvt-Forestry/Paper",
      "CVT_GAMING": "Cvt-Gaming",
      "CVT_GAS_DISTRIBUTION": "Cvt-Gas Distribution",
      "CVT_HEALTH_FACILITIES": "Cvt-Health Facilities",
      "CVT_HEALTH_SERVICES": "Cvt-Health Services",
      "CVT_HOTELS": "Cvt-Hotels",
      "CVT_HOUSING_ASSOCIATION": "Cvt-Housing Association",
      "CVT_INSURANCE_BROKERAGE": "Cvt-Insurance Brokerage",
      "CVT_INTEGRATED_ENERGY": "Cvt-Integrated Energy",
      "CVT_INVESTMENTS_MISC_FINANCIAL_SERVICES": "Cvt-Investments & Misc Financial Services",
      "CVT_LIFE_INSURANCE": "Cvt-Life Insurance",
      "CVT_MACHINERY": "Cvt-Machinery",
      "CVT_MANAGED_CARE": "Cvt-Managed Care",
      "CVT_MEDIA_CONTENT": "Cvt-Media Content",
      "CVT_MEDIA_DIVERSIFIED": "Cvt-Media - Diversified",
      "CVT_MEDICAL_PRODUCTS": "Cvt-Medical Products",
      "CVT_METALS_MINING_EXCLUDING_STEEL": "Cvt-Metals/Mining Excluding Steel",
      "CVT_MONOLINE_INSURANCE": "Cvt-Monoline Insurance",
      "CVT_MULTI_LINE_INSURANCE": "Cvt-Multi-Line Insurance",
      "CVT_NON_ELECTRIC_UTILITIES": "Cvt-Non-Electric Utilities",
      "CVT_OIL_FIELD_EQUIPMENT_SERVICES": "Cvt-Oil Field Equipment & Services",
      "CVT_OIL_REFINING_MARKETING": "Cvt-Oil Refining & Marketing",
      "CVT_PACKAGING": "Cvt-Packaging",
      "CVT_PERSONAL_HOUSEHOLD_PRODUCTS": "Cvt-Personal & Household Products",
      "CVT_PHARMACEUTICALS": "Cvt-Pharmaceuticals",
      "CVT_PRINTING_PUBLISHING": "Cvt-Printing & Publishing",
      "CVT_P_C": "Cvt-P&C",
      "CVT_RAIL": "Cvt-Rail",
      "CVT_REAL_ESTATE_DEV_MGT": "Cvt-RealEstate Dev & Mgt",
      "CVT_RECREATION_TRAVEL": "Cvt-Recreation & Travel",
      "CVT_REINSURANCE": "Cvt-Reinsurance",
      "CVT_REI_TS": "Cvt-REITs",
      "CVT_RESTAURANTS": "Cvt-Restaurants",
      "CVT_SOFTWARE_SERVICES": "Cvt-Software/Services",
      "CVT_SPECIALTY_RETAIL": "Cvt-Specialty Retail",
      "CVT_STEEL_PRODUCERS_PRODUCTS": "Cvt-Steel Producers/Products",
      "CVT_SUPPORT_SERVICES": "Cvt-Support-Services",
      "CVT_TECH_HARDWARE_EQUIPMENT": "Cvt-Tech Hardware & Equipment",
      "CVT_TELECOM_SATELLITE": "Cvt-Telecom - Satellite",
      "CVT_TELECOM_WIRELESS": "Cvt-Telecom - Wireless",
      "CVT_TELECOM_WIRELINE_INTEGRATED_SERVICES": "Cvt-Telecom - Wireline Integrated & Services",
      "CVT_THEATERS_ENTERTAINMENT": "Cvt-Theaters & Entertainment",
      "CVT_TOBACCO": "Cvt-Tobacco",
      "CVT_TRANSPORT_INFRASTRUCTURE_SERVICES": "Cvt-Transport Infrastructure/Services",
      "CVT_TRUCKING_DELIVERY": "Cvt-Trucking & Delivery",
      "DEPARTMENT_STORES": "Department Stores",
      "DISCOUNT_STORES": "Discount Stores",
      "DIVERSIFIED_CAPITAL_GOODS": "Diversified Capital Goods",
      "ELECTRIC_DISTR_TRANS": "Electric-Distr/Trans",
      "ELECTRIC_GENERATION": "Electric-Generation",
      "ELECTRIC_INTEGRATED": "Electric-Integrated",
      "ELECTRONICS": "Electronics",
      "ENERGY_EXPLORATION_PRODUCTION": "Energy - Exploration & Production",
      "ENVIRONMENTAL": "Environmental",
      "ETM": "ETM",
      "FOOD_DRUG_RETAILERS": "Food & Drug Retailers",
      "FOOD_WHOLESALE": "Food - Wholesale",
      "FOREIGN_SOVEREIGN": "Foreign Sovereign",
      "FORESTRY_PAPER": "Forestry/Paper",
      "GAMING": "Gaming",
      "GAS_DISTRIBUTION": "Gas Distribution",
      "GOVERNMENT_GUARANTEED": "Government Guaranteed",
      "GO_LOCAL": "GO - Local",
      "GO_STATE": "GO - State",
      "HEALTH_FACILITIES": "Health Facilities",
      "HEALTH_SERVICES": "Health Services",
      "HOTELS": "Hotels",
      "HOUSING_ASSOCIATION": "Housing Association",
      "INSURANCE_BROKERAGE": "Insurance Brokerage",
      "INTEGRATED_ENERGY": "Integrated Energy",
      "INVESTMENTS_MISC_FINANCIAL_SERVICES": "Investments & Misc Financial Services",
      "LIFE_INSURANCE": "Life Insurance",
      "LOAN_ADVERTISING": "Loan-Advertising",
      "LOAN_AEROSPACE_DEFENSE": "Loan-Aerospace/Defense",
      "LOAN_AIR_TRANSPORTATION": "Loan-AirTransportation",
      "LOAN_AUTOMAKERS": "Loan-Automakers",
      "LOAN_AUTO_LOANS": "Loan-AutoLoans",
      "LOAN_AUTO_PARTS_EQUIPMENT": "Loan-AutoParts&Equipment",
      "LOAN_BANKING": "Loan-Banking",
      "LOAN_BEVERAGE": "Loan-Beverage",
      "LOAN_BROKERAGE": "Loan-Brokerage",
      "LOAN_BUILDING_CONSTRUCTION": "Loan-Building&Construction",
      "LOAN_BUILDING_MATERIALS": "Loan-BuildingMaterials",
      "LOAN_CABLE_SATELLITE_TV": "Loan-Cable&SatelliteTV",
      "LOAN_CHEMICALS": "Loan-Chemicals",
      "LOAN_CONS_COMM_LEASE_FINANCING": "Loan-Cons/Comm/LeaseFinancing",
      "LOAN_DEPARTMENT_STORES": "Loan-DepartmentStores",
      "LOAN_DISCOUNT_STORES": "Loan-DiscountStores",
      "LOAN_DIVERSIFIED_CAPITAL_GOODS": "Loan-DiversifiedCapitalGoods",
      "LOAN_ELECTRIC_DISTR_TRANS": "Loan-Electric-Distr/Trans",
      "LOAN_ELECTRIC_GENERATION": "Loan-Electric-Generation",
      "LOAN_ELECTRIC_INTEGRATED": "Loan-Electric-Integrated",
      "LOAN_ELECTRONICS": "Loan-Electronics",
      "LOAN_ENERGY_EXPLORATION_PRODUCTION": "Loan-Energy-Exploration&Production",
      "LOAN_ENVIRONMENTAL": "Loan-Environmental",
      "LOAN_FOOD_DRUG_RETAILERS": "Loan-Food&DrugRetailers",
      "LOAN_FOOD_WHOLESALE": "Loan-Food-Wholesale",
      "LOAN_FORESTRY_PAPER": "Loan-Forestry/Paper",
      "LOAN_GAMING": "Loan-Gaming",
      "LOAN_GAS_DISTRIBUTION": "Loan-GasDistribution",
      "LOAN_HEALTH_FACILITIES": "Loan-HealthFacilities",
      "LOAN_HEALTH_SERVICES": "Loan-HealthServices",
      "LOAN_HOTELS": "Loan-Hotels",
      "LOAN_HOUSING_ASSOCIATION": "Loan-HousingAssociation",
      "LOAN_INSURANCE_BROKERAGE": "Loan-InsuranceBrokerage",
      "LOAN_INTEGRATED_ENERGY": "Loan-IntegratedEnergy",
      "LOAN_INVESTMENTS_MISC_FINANCIAL_SERVICES": "Loan-Investments&MiscFinancialServices",
      "LOAN_LIFE_INSURANCE": "Loan-LifeInsurance",
      "LOAN_MACHINERY": "Loan-Machinery",
      "LOAN_MANAGED_CARE": "Loan-ManagedCare",
      "LOAN_MEDIA_CONTENT": "Loan-MediaContent",
      "LOAN_MEDIA_DIVERSIFIED": "Loan-Media-Diversified",
      "LOAN_MEDICAL_PRODUCTS": "Loan-MedicalProducts",
      "LOAN_METALS_MINING_EXCLUDING_STEEL": "Loan-Metals/MiningExcludingSteel",
      "LOAN_MONOLINE_INSURANCE": "Loan-MonolineInsurance",
      "LOAN_MULTI_LINE_INSURANCE": "Loan-Multi-LineInsurance",
      "LOAN_NON_ELECTRIC_UTILITIES": "Loan-Non-ElectricUtilities",
      "LOAN_OIL_FIELD_EQUIPMENT_SERVICES": "Loan-OilFieldEquipment&Services",
      "LOAN_OIL_REFINING_MARKETING": "Loan-OilRefining&Marketing",
      "LOAN_PACKAGING": "Loan-Packaging",
      "LOAN_PERSONAL_HOUSEHOLD_PRODUCTS": "Loan-Personal&HouseholdProducts",
      "LOAN_PHARMACEUTICALS": "Loan-Pharmaceuticals",
      "LOAN_PRINTING_PUBLISHING": "Loan-Printing&Publishing",
      "LOAN_P_C": "Loan-P&C",
      "LOAN_RAIL": "Loan-Rail",
      "LOAN_REAL_ESTATE_DEV_MGT": "Loan-RealEstateDev&Mgt",
      "LOAN_RECREATION_TRAVEL": "Loan-Recreation&Travel",
      "LOAN_REINSURANCE": "Loan-Reinsurance",
      "LOAN_REI_TS": "Loan-REITs",
      "LOAN_RESTAURANTS": "Loan-Restaurants",
      "LOAN_SOFTWARE_SERVICES": "Loan-Software/Services",
      "LOAN_SPECIALTY_RETAIL": "Loan-SpecialtyRetail",
      "LOAN_STEEL_PRODUCERS_PRODUCTS": "Loan-SteelProducers/Products",
      "LOAN_SUPPORT_SERVICES": "Loan-Support-Services",
      "LOAN_TECH_HARDWARE_EQUIPMENT": "Loan-TechHardware&Equipment",
      "LOAN_TELECOM_SATELLITE": "Loan-Telecom-Satellite",
      "LOAN_TELECOM_WIRELESS": "Loan-Telecom-Wireless",
      "LOAN_TELECOM_WIRELINE_INTEGRATED_SERVICES": "Loan-Telecom-WirelineIntegrated&Services",
      "LOAN_THEATERS_ENTERTAINMENT": "Loan-Theaters&Entertainment",
      "LOAN_TOBACCO": "Loan-Tobacco",
      "LOAN_TRANSPORT_INFRASTRUCTURE_SERVICES": "Loan-TransportInfrastructure/Services",
      "LOAN_TRUCKING_DELIVERY": "Loan-Trucking&Delivery",
      "LOCAL_AUTHORITY": "Local-Authority",
      "MACHINERY": "Machinery",
      "MANAGED_CARE": "Managed Care",
      "MEDIA_CONTENT": "Media Content",
      "MEDIA_DIVERSIFIED": "Media - Diversified",
      "MEDICAL_PRODUCTS": "Medical Products",
      "METALS_MINING_EXCLUDING_STEEL": "Metals/Mining Excluding Steel",
      "MONOLINE_INSURANCE": "Monoline Insurance",
      "MORTGAGE_BACKED": "Mortgage Backed",
      "MORTGAGE_COVERED_BONDS": "Mortgage Covered Bonds",
      "MULTI_LINE_INSURANCE": "Multi-Line Insurance",
      "NON_AGENCY_CMBS": "Non-Agency CMBS",
      "NON_ELECTRIC_UTILITIES": "Non-Electric Utilities",
      "OIL_FIELD_EQUIPMENT_SERVICES": "Oil Field Equipment & Services",
      "OIL_REFINING_MARKETING": "Oil Refining & Marketing",
      "OTHER_COVERED_BONDS": "Other Covered Bonds",
      "PAC": "PAC",
      "PACKAGING": "Packaging",
      "PAC_Z": "PAC Z",
      "PERSONAL_HOUSEHOLD_PRODUCTS": "Personal & Household Products",
      "PFD_ADVERTISING": "Pfd-Advertising",
      "PFD_AEROSPACE_DEFENSE": "Pfd-Aerospace/Defense",
      "PFD_AGENCY": "Pfd-Agency",
      "PFD_AIR_TRANSPORTATION": "Pfd-Air Transportation",
      "PFD_AUTOMAKERS": "Pfd-Automakers",
      "PFD_AUTO_LOANS": "Pfd-Auto Loans",
      "PFD_AUTO_PARTS_EQUIPMENT": "Pfd-Auto Parts & Equipment",
      "PFD_BANKING": "Pfd-Banking",
      "PFD_BEVERAGE": "Pfd-Beverage",
      "PFD_BROKERAGE": "Pfd-Brokerage",
      "PFD_BUILDING_CONSTRUCTION": "Pfd-Building & Construction",
      "PFD_BUILDING_MATERIALS": "Pfd-Building Materials",
      "PFD_CABLE_SATELLITE_TV": "Pfd-Cable & Satellite TV",
      "PFD_CHEMICALS": "Pfd-Chemicals",
      "PFD_CONS_COMM_LEASE_FINANCING": "Pfd-Cons/Comm/Lease Financing",
      "PFD_DEPARTMENT_STORES": "Pfd-Department Stores",
      "PFD_DISCOUNT_STORES": "Pfd-Discount Stores",
      "PFD_DIVERSIFIED_CAPITAL_GOODS": "Pfd-Diversified Capital Goods",
      "PFD_ELECTRIC_DISTR_TRANS": "Pfd-Electric-Distr/Trans",
      "PFD_ELECTRIC_GENERATION": "Pfd-Electric-Generation",
      "PFD_ELECTRIC_INTEGRATED": "Pfd-Electric-Integrated",
      "PFD_ELECTRONICS": "Pfd-Electronics",
      "PFD_ENERGY_EXPLORATION_PRODUCTION": "Pfd-Energy - Exploration & Production",
      "PFD_ENVIRONMENTAL": "Pfd-Environmental",
      "PFD_FOOD_DRUG_RETAILERS": "Pfd-Food & Drug Retailers",
      "PFD_FOOD_WHOLESALE": "Pfd-Food - Wholesale",
      "PFD_FORESTRY_PAPER": "Pfd-Forestry/Paper",
      "PFD_GAMING": "Pfd-Gaming",
      "PFD_GAS_DISTRIBUTION": "Pfd-Gas Distribution",
      "PFD_HEALTH_FACILITIES": "Pfd-Health Facilities",
      "PFD_HEALTH_SERVICES": "Pfd-Health Services",
      "PFD_HOTELS": "Pfd-Hotels",
      "PFD_HOUSING_ASSOCIATION": "Pfd-Housing Association",
      "PFD_INSURANCE_BROKERAGE": "Pfd-Insurance Brokerage",
      "PFD_INTEGRATED_ENERGY": "Pfd-Integrated Energy",
      "PFD_INVESTMENTS_MISC_FINANCIAL_SERVICES": "Pfd-Investments & Misc Financial Services",
      "PFD_LIFE_INSURANCE": "Pfd-Life Insurance",
      "PFD_MACHINERY": "Pfd-Machinery",
      "PFD_MANAGED_CARE": "Pfd-Managed Care",
      "PFD_MEDIA_CONTENT": "Pfd-Media Content",
      "PFD_MEDIA_DIVERSIFIED": "Pfd-Media - Diversified",
      "PFD_MEDICAL_PRODUCTS": "Pfd-Medical Products",
      "PFD_METALS_MINING_EXCLUDING_STEEL": "Pfd-Metals/Mining Excluding Steel",
      "PFD_MONOLINE_INSURANCE": "Pfd-Monoline Insurance",
      "PFD_MULTI_LINE_INSURANCE": "Pfd-Multi-Line Insurance",
      "PFD_NON_ELECTRIC_UTILITIES": "Pfd-Non-Electric Utilities",
      "PFD_OIL_FIELD_EQUIPMENT_SERVICES": "Pfd-Oil Field Equipment & Services",
      "PFD_OIL_REFINING_MARKETING": "Pfd-Oil Refining & Marketing",
      "PFD_PACKAGING": "Pfd-Packaging",
      "PFD_PERSONAL_HOUSEHOLD_PRODUCTS": "Pfd-Personal & Household Products",
      "PFD_PHARMACEUTICALS": "Pfd-Pharmaceuticals",
      "PFD_PRINTING_PUBLISHING": "Pfd-Printing & Publishing",
      "PFD_P_C": "Pfd-P&C",
      "PFD_RAIL": "Pfd-Rail",
      "PFD_REAL_ESTATE_DEV_MGT": "Pfd-RealEstate Dev & Mgt",
      "PFD_RECREATION_TRAVEL": "Pfd-Recreation & Travel",
      "PFD_REINSURANCE": "Pfd-Reinsurance",
      "PFD_REI_TS": "Pfd-REITs",
      "PFD_RESTAURANTS": "Pfd-Restaurants",
      "PFD_SOFTWARE_SERVICES": "Pfd-Software/Services",
      "PFD_SPECIALTY_RETAIL": "Pfd-Specialty Retail",
      "PFD_STEEL_PRODUCERS_PRODUCTS": "Pfd-Steel Producers/Products",
      "PFD_SUPPORT_SERVICES": "Pfd-Support-Services",
      "PFD_TECH_HARDWARE_EQUIPMENT": "Pfd-Tech Hardware & Equipment",
      "PFD_TELECOM_SATELLITE": "Pfd-Telecom - Satellite",
      "PFD_TELECOM_WIRELESS": "Pfd-Telecom - Wireless",
      "PFD_TELECOM_WIRELINE_INTEGRATED_SERVICES": "Pfd-Telecom - Wireline Integrated & Services",
      "PFD_THEATERS_ENTERTAINMENT": "Pfd-Theaters & Entertainment",
      "PFD_TOBACCO": "Pfd-Tobacco",
      "PFD_TRANSPORT_INFRASTRUCTURE_SERVICES": "Pfd-Transport Infrastructure/Services",
      "PFD_TRUCKING_DELIVERY": "Pfd-Trucking & Delivery",
      "PHARMACEUTICALS": "Pharmaceuticals",
      "PRE_REFUNDED": "Pre-Refunded",
      "PRE_REFUNDED_2": "Pre-Refunded",
      "PRINTING_PUBLISHING": "Printing & Publishing",
      "PUBLIC_LOAN_COVERED_BONDS": "Public Loan Covered Bonds",
      "P_C": "P&C",
      "RAIL": "Rail",
      "REAL_ESTATE_DEV_MGT": "RealEstate Dev & Mgt",
      "RECREATION_TRAVEL": "Recreation & Travel",
      "REINSURANCE": "Reinsurance",
      "REI_TS": "REITs",
      "RESTAURANTS": "Restaurants",
      "REVENUE_AIRPORT": "Revenue - Airport",
      "REVENUE_EDUCATION": "Revenue - Education",
      "REVENUE_HEALTH": "Revenue - Health",
      "REVENUE_HOSPITALS": "Revenue - Hospitals",
      "REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE": "Revenue - Industrial Development Revenue",
      "REVENUE_LEASING_COPS_APPROPRIATIONS": "Revenue - Leasing COPS & Appropriations",
      "REVENUE_MISC": "Revenue - Misc",
      "REVENUE_MULTI_FAMILY_HOUSING": "Revenue - Multi-Family Housing",
      "REVENUE_POLLUTION_CONTROL": "Revenue - Pollution Control",
      "REVENUE_POWER": "Revenue - Power",
      "REVENUE_SINGLE_FAMILY_HOUSING": "Revenue - Single Family Housing",
      "REVENUE_TAX": "Revenue - Tax",
      "REVENUE_TOBACCO": "Revenue - Tobacco",
      "REVENUE_TOLL_TURNPIKE": "Revenue - Toll & Turnpike",
      "REVENUE_TRANSPORTATION": "Revenue - Transportation",
      "REVENUE_UTILITIES_OTHER": "Revenue - Utilities - Other",
      "REVENUE_WATER_SEWER": "Revenue - Water & Sewer",
      "SEQUENTIAL": "Sequential",
      "SEQUENTIAL_Z": "Sequential Z",
      "SOFTWARE_SERVICES": "Software/Services",
      "SOVEREIGN": "Sovereign",
      "SPECIALTY_RETAIL": "Specialty Retail",
      "STEEL_PRODUCERS_PRODUCTS": "Steel Producers/Products",
      "STRUCTURED_IO": "Structured IO",
      "STRUCTURED_PO": "Structured PO",
      "SUPPORT_SERVICES": "Support-Services",
      "SUPPORT_Z": "Support Z",
      "SUPRANATIONAL": "Supranational",
      "TAXABLE_ETM": "Taxable ETM",
      "TAXABLE_GO_LOCAL": "Taxable GO - Local",
      "TAXABLE_GO_STATE": "Taxable GO - State",
      "TAXABLE_REVENUE_AIRPORT": "Taxable Revenue - Airport",
      "TAXABLE_REVENUE_EDUCATION": "Taxable Revenue - Education",
      "TAXABLE_REVENUE_HEALTH": "Taxable Revenue - Health",
      "TAXABLE_REVENUE_HOSPITALS": "Taxable Revenue - Hospitals",
      "TAXABLE_REVENUE_INDUSTRIAL_DEVELOPMENT_REVENUE": "Taxable Revenue - Industrial Development Revenue",
      "TAXABLE_REVENUE_LEASING_COPS_APPROPRIATIONS": "Taxable Revenue - Leasing COPS & Appropriations",
      "TAXABLE_REVENUE_MISC": "Taxable Revenue - Misc",
      "TAXABLE_REVENUE_MULTI_FAMILY_HOUSING": "Taxable Revenue - Multi-Family Housing",
      "TAXABLE_REVENUE_POLLUTION_CONTROL": "Taxable Revenue - Pollution Control",
      "TAXABLE_REVENUE_POWER": "Taxable Revenue - Power",
      "TAXABLE_REVENUE_SINGLE_FAMILY_HOUSING": "Taxable Revenue - Single Family Housing",
      "TAXABLE_REVENUE_TAX": "Taxable Revenue - Tax",
      "TAXABLE_REVENUE_TOBACCO": "Taxable Revenue - Tobacco",
      "TAXABLE_REVENUE_TOLL_TURNPIKE": "Taxable Revenue - Toll & Turnpike",
      "TAXABLE_REVENUE_TRANSPORTATION": "Taxable Revenue - Transportation",
      "TAXABLE_REVENUE_UTILITIES_OTHER": "Taxable Revenue - Utilities - Other",
      "TAXABLE_REVENUE_WATER_SEWER": "Taxable Revenue - Water & Sewer",
      "TECH_HARDWARE_EQUIPMENT": "Tech Hardware & Equipment",
      "TELECOM_SATELLITE": "Telecom - Satellite",
      "TELECOM_WIRELESS": "Telecom - Wireless",
      "TELECOM_WIRELINE_INTEGRATED_SERVICES": "Telecom - Wireline Integrated & Services",
      "THEATERS_ENTERTAINMENT": "Theaters & Entertainment",
      "TOBACCO": "Tobacco",
      "TRANSPORT_INFRASTRUCTURE_SERVICES": "Transport Infrastructure/Services",
      "TRUCKING_DELIVERY": "Trucking & Delivery",
      "TRUST_IO": "Trust IO",
      "TRUST_PO": "Trust PO",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1InstrumentStatus": {
      "LINKED": "Linked",
      "UNLINKED": "Unlinked",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1InstrumentSummaryName": {
      "InstrumentSummary": "Instrument Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1InstrumentType": {
      "COMMODITY_SPOT_RATE": "Commodity Spot Rate",
      "COMPOSITE_UNIT": "Composite Unit",
      "DEBT": "Debt",
      "DEPOSITORY_RECEIPT": "Depository Receipt",
      "ENTITLEMENT": "Entitlement",
      "EQUITY": "Equity",
      "EXCHANGE_RATE": "Exchange Rate",
      "FUND": "Fund",
      "FUTURE": "Future",
      "HYBRID": "Hybrid",
      "INDEX": "Index",
      "INTEREST_RATE": "Interest Rate",
      "NONE": "None",
      "OPTION": "Option",
      "OTHER_DERIVATIVES": "Other Derivatives",
      "STRATEGY": "Strategy",
      "UNKNOWN": "Unknown",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1IssueStatusReasonType": {
      "ALSO_TRADING_WHEN_ISSUED_WHEN_DISTRIBUTED": "Also Trading When Issued/When Distributed",
      "CALL_ANNOUNCED": "Call Announced",
      "CALL_EFFECTIVE": "Call Effective",
      "CEASED_TRADING": "Ceased Trading",
      "CONVERTED": "Converted",
      "DELISTED": "Delisted",
      "DUPLICATE_ISSUED_IN_ERROR": "Duplicate Issued In Error",
      "EXCHANGED": "Exchanged",
      "FULLY_PREPAID": "Fully Prepaid",
      "ISSUED_IN_ERROR": "Issued in Error",
      "ISSUE_CONSOLIDATION_WITH_ANOTHER_SERIES": "Issue Consolidation with another series",
      "LIQUIDATED": "Liquidated",
      "LIVE": "Live",
      "MATURED": "Matured",
      "MATURITY_ANNOUNCED": "Maturity Announced",
      "MERGER_AND_ACQUISITION": "Merger and Acquisition",
      "NONE": "None",
      "PUT_ANNOUNCED": "Put Announced",
      "PUT_EFFECTIVE": "Put Effective",
      "REORGANIZATION": "Reorganization",
      "REPURCHASED_TENDERED": "Repurchased/Tendered",
      "SUSPENDED": "Suspended",
      "TERMINATED": "Terminated",
      "UNKNOWN": "Unknown",
      "UNSPECIFIED": "Unspecified",
      "WARRANTS_DETACHED_OR_EXERCISED": "Warrants Detached or Exercised",
      "WARRANTS_EXPIRED": "Warrants Expired"
    },
    "ExcIceGsmV1ListingStatusDetailType": {
      "AFTER_SUSPENSION": "After Suspension",
      "DELETED": "Deleted",
      "FUTURE_DELETION": "Future Deletion",
      "NEW": "New",
      "NOT_TRADABLE": "Not Tradable",
      "NOT_YET_PRICING": "Not Yet Pricing",
      "REINSTATED": "Reinstated",
      "REPLACED": "Replaced",
      "SPECIAL_SITUATION": "Special Situation",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1ListingTradingStatusType": {
      "ACTIVE": "Active",
      "ALSO_TRADING_WHEN_ISSUED": "Also Trading When Issued",
      "DELISTED": "Delisted",
      "INACTIVE": "Inactive",
      "SUSPENSION": "Suspension",
      "UNSPECIFIED": "Unspecified",
      "WHEN_ISSUED_LINE": "When Issued Line"
    },
    "ExcIceGsmV1MuniFedTaxType": {
      "SUBJECT_TO_AMT": "Subject to AMT",
      "TAXABLE": "Taxable",
      "TAX_EXEMPT": "Tax-exempt",
      "UNKNOWN": "Unknown",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1PreferredType": {
      "AUCTION_RATE_PREFERRED": "Auction Rate Preferred",
      "GENUSSCHEIN": "Genusschein",
      "NONE": "None",
      "OTHER_PARTICIPATING_SHARES": "Other Participating Shares",
      "PIBS_PERMANENT_INTEREST_BEARING_SHARES": "PIBS (Permanent Interest Bearing Shares)",
      "RISPARMIO": "Risparmio",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcIceGsmV1WarrantType": {
      "COVERED": "Covered",
      "EQUITY": "Equity",
      "NONE": "None",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcIceGsmV1InstrumentQueryServiceInstrumentListFilterableFields": {
      "data": {
        "assetId": "Asset",
        "identifiers": {
          "cusip": "CUSIP",
          "isin": "ISIN"
        },
        "instrument": {
          "type": "Data Instrument Type"
        }
      },
      "instrumentId": "Instrument",
      "status": "Status"
    }
  },
  "oneOf": {
    "ExcIceGsmV1InstrumentEventType": {
      "ingested": "Ingested",
      "linked": "Linked",
      "unlinked": "Unlinked"
    }
  },
  "searchEnum": {
    "ExcIceGsmV1InstrumentQueryServiceInstrumentListSearchableFields": {
      "data": {
        "identifiers": {
          "symbol": "Data Identifiers Symbol"
        },
        "name": "Name"
      }
    }
  },
  "sortEnum": {
    "ExcIceGsmV1InstrumentQueryServiceInstrumentListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}